import { Link } from "react-router-dom";
import Image from "../../Components/Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";
import RoutesPath from "../../Utils/RoutesPath";
import React from "react";

const PageTitleBanner = ({ 
    PageTitle,
    PageHead, 
    startPoint = "Home", 
    currentTitle = [],
    breadCrumpPageTitle, // New prop for the current page title
}) => {
    return (
        <div className="page-title-banner">
            <div className="d-flex flex-column page-title-banner-container">
            <h2 className=" fw-500 medium-text  white mb-2">{PageHead}</h2>
                <h2 className="page-title Title fw-600 white mb-2">{PageTitle}</h2>
                <div className="page-title-breadcrump mt-4 d-flex gap-2 align-items-center flex-wrap">
                    <Link to={RoutesPath.home}>
                        <h4 className="medium-text fw-400 white mb-0 text-uppercase cursor-pointer">
                            {startPoint}
                        </h4>
                    </Link>
                    <Image
                        className="page-title-breadcrump-arrow"
                        src={SvgImages.breadcrumpArrow}
                    />
                    {currentTitle.map((item, index) => (
                        <React.Fragment key={index}>
                            {item.path ? (
                                <Link to={item.path}>
                                    <h4 className="medium-text fw-400 white mb-0 text-uppercase cursor-pointer">
                                        {item.currentTitle}
                                    </h4>
                                </Link>
                            ) : (
                                <h4 className="medium-text fw-400 orangeAccentColor mb-0 text-uppercase">
                                    {item.currentTitle}
                                </h4>
                            )}
                            {index < currentTitle.length - 1 && (
                                <Image
                                    className="page-title-breadcrump-arrow"
                                    src={SvgImages.breadcrumpArrow}
                                />
                            )}
                        </React.Fragment>
                    ))}
                    {/* Display current title in orange */}
                    {breadCrumpPageTitle && (
                        <h4 className="medium-text fw-400 orangeAccentColor mb-0 text-uppercase">
                            {breadCrumpPageTitle}
                        </h4>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PageTitleBanner;
